import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getSearchQuickSubs, getPageCount } from 'reducers';
import { searchSubs } from 'actions/quickSubs';
import SearchSubsComponent from './SearchSubs';

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
  },
) => ({
  subs: getSearchQuickSubs(state, page),
  pageCount: getPageCount(state, 'quickSubs', `search`, page),
  fields: ['first_name', 'last_name', 'mdn', 'user_profile', 'device_id'],
  page,
  subscriptionRoute: (subId) => `/quick/subscriptions/${subId}/view`,
  pageRoute: (pageNum) => `/quick/subsriptions/search/page/${pageNum}`,
  isQuick: true,
  carrierTitle: 'Quick',
});

const mapDispatchToProps = {
  searchSubs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchSubsComponent),
);
